
























import {
  Component, Prop, PropSync, Vue,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    PrimaryButton,
    TextButton,
  },
})
export default class ApprovePartner extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @Prop({}) foodTruckName!: string;

  @Prop({}) saving!: string;

  public onApprove() {
    this.$emit('approve');
  }

  public onCancel() {
    this.dialogSync = false;
    this.$emit('cancel');
  }
}
